import Cookies from 'js-cookie';

const tracker = 'Amplitude (Trackers)';

interface AmplitudeCookie {
  accepted: boolean;
  name: typeof tracker;
}

const parseCookie = (cookieName: string) => {
  const cookieList = Cookies.get(cookieName);

  if (!cookieList) {
    return false;
  }

  const jsonParsedCookieList = JSON.parse(cookieList);
  const amplitudeCookie: AmplitudeCookie | undefined =
    jsonParsedCookieList.tracking.find(({ name }) => name === tracker);

  return !!amplitudeCookie?.accepted;
};

const checkHasCookieConsentBO = () => parseCookie('cookie_consent_list_bo');

const checkHasCookieConsentFO = (cookieBannerEnabled: boolean) => {
  if (cookieBannerEnabled === false) {
    return true;
  }

  return parseCookie('cookie_consent_list_fo');
};

interface AmplitudeProps {
  amplitudeIsEnabled: boolean;
  cookieBannerEnabled: boolean;
  env: 'bo' | 'fo' | 'po';
}

export const checkHasCookieConsent = ({
  cookieBannerEnabled,
  amplitudeIsEnabled,
  env,
}: AmplitudeProps) => {
  if (amplitudeIsEnabled === false) {
    return false;
  }

  if (env === 'bo') {
    return checkHasCookieConsentBO();
  }

  if (env === 'fo') {
    return checkHasCookieConsentFO(cookieBannerEnabled);
  }

  // not activated on PO
  return false;
};

export const checkCanConnectAmplitude = ({
  amplitudeIsEnabled,
  env,
}: AmplitudeProps) => {
  if (amplitudeIsEnabled === false) {
    return false;
  }

  if (env === 'bo' || env === 'fo') {
    return true;
  }

  // not activated on PO
  return false;
};
